module.exports = __webpack_public_path__ + "img/rugdoc.3bc0e85a.jpeg";